module.exports = __webpack_public_path__ + "img/aue-logo.c9b3cf6d.png";